import React from "react";
import "../SendCreate.css";
// import "./ToolTipDisplay.css";

const FeatureTooltip = ({ label, selectedLanguage, isLocked }) => {
const TOOLTIP_MAP = {
    [selectedLanguage.LstLanguageCodes.UI_IDLeakers]: selectedLanguage.LstLanguageCodes.UI_AddsintheDocAdynamic,
    [selectedLanguage.LstLanguageCodes.UI_TimeStamp]: selectedLanguage.LstLanguageCodes.UI_AddsAtimeStamp,
    [selectedLanguage.LstLanguageCodes.UI_CanPrint]: selectedLanguage.LstLanguageCodes.UI_CanPrintInfoText,
    [selectedLanguage.LstLanguageCodes.UI_AllowResponsesTo]: selectedLanguage.LstLanguageCodes.UI_AllowsTheDocOwnerToRoute,
    [selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeText]: selectedLanguage.LstLanguageCodes.UI_SendVerificationText,
    [selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail]: selectedLanguage.LstLanguageCodes.UI_SendVerificationToEmail,
    [selectedLanguage.LstLanguageCodes.UI_ProofOfSending]: selectedLanguage.LstLanguageCodes.UI_WhenThisFeatureisEnabledTheSender,
    [selectedLanguage.LstLanguageCodes.UI_DisplayDistributionlist]: selectedLanguage.LstLanguageCodes.UI_DisplaysTheList,
    [selectedLanguage.LstLanguageCodes.UI_NotificationofReading]: selectedLanguage.LstLanguageCodes.UI_AbilityToReceiveAnotification,
    [selectedLanguage.LstLanguageCodes.UI_Voting]: selectedLanguage.LstLanguageCodes.UI_AllowsReaderstoexpress,
    [selectedLanguage.LstLanguageCodes.UI_ShareVotes]: selectedLanguage.LstLanguageCodes.UI_whenthisFeatureisEnabledreaders,
    [selectedLanguage.LstLanguageCodes.UI_EDisclosure]: selectedLanguage.LstLanguageCodes.UI_ThisFeatureAllowsSenderTo,
    [selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader]: selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader,
    [selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument]: selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument,
    [selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerReader]: selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerReader,
    [selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerDocument]: selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerDocument,
   [selectedLanguage.LstLanguageCodes.UI_RestrictToDomains]: selectedLanguage.LstLanguageCodes.UI_RestrictsAccesstoDoc,
    [selectedLanguage.LstLanguageCodes.UI_AllowedIP]: selectedLanguage.LstLanguageCodes.UI_RestrictsAccesstoAnIP,
    [selectedLanguage.LstLanguageCodes.UI_BannedRegions]: selectedLanguage.LstLanguageCodes.UI_AllowsthesenderofanRdoc

  };
  const tooltipText = TOOLTIP_MAP[[label] || label];
  if (!tooltipText) return null;
  const handleMouseEnter = (e) => {
    const tooltip = e.currentTarget.querySelector(".ModToollTips");
    if (!tooltip) return;
    const icon = e.currentTarget.getBoundingClientRect();
    tooltip.style.position = "fixed";
    tooltip.style.top = `${icon.top - 30}px`;
    //  tooltip.style.top = `${iconRect.top - tooltip.offsetHeight - 10}px`;
    tooltip.style.left = `${icon.right - 10}px`;
  };
  return (
    <span
      className="toolltipModified"
      onMouseEnter={handleMouseEnter}
      style={{ marginLeft: 6, position: "relative", display: 'inline-flex' }}
    >
      <span
        className="material-icons"
        style={{
          fontSize: 16,
          color: "#2980cc",
          cursor: isLocked ? "not-allowed" : "pointer",
        }}
      >
        info
      </span>
      {!isLocked && (
        <span style={{ marginLeft: "30px" }} className="ModToollTips">
          {tooltipText}
        </span>
      )}
    </span>
  );
};

export default FeatureTooltip;
